import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import { UserModel} from '@/libs/Api';
import {BusinessModule} from '@/libs/core/models/business-module';
import { AdminUsersDataService } from '../admin-users-data-service';

export const adminUsersStore = registerCrudStore<UserModel, UserModel>(BusinessModule.AdminUser, new AdminUsersDataService());
